import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { Button } from '@mui/material'
import { motion } from 'framer-motion'
import { colors } from '@global/constants'

export const Section = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: auto;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  font-family: 'Noto Sans', sans-serif;
  margin-bottom: 20px;
`

export const Wrapper = styled.div`
  padding: 24px 20px;
  transition: all 1s cubic-bezier(0.68, -0.55, 0.27, 1.55);
`

export const Card = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 35px;
`

export const hover = css`
  :hover {
    cursor: pointer;
    transform: translateY(-2px);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    transition: all 250ms;
  }
`

export const Header = styled.header`
  display: flex;
  flex-direction: row;
`

export const Title = styled.h1`
  color: #000;
  font-size: 16px;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 700;
  margin: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`

export const hoverHighlight = css`
  color: ${colors.blue.hover};
`

export const Details = styled.div`
  display: flex;
  align-items: center;
  font-size: 12px;
  padding-top: 7px;
  color: ${colors.sonicSilver};

  .MuiSvgIcon-root {
    margin-right: 4px;
  }

  > div {
    display: flex;
    align-items: center;
  }
`

export const Description = styled(motion.div)`
  padding-top: 15px;
  font-size: 12px;
  font-family: 'Noto Sans', sans-serif;
  color: ${colors.sonicSilver};
`

export const ClickableArea = styled.div`
  flex: 1;
  min-width: 0;
`

export const ButtonArea = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Buttons = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  flex: 1;
  gap: 10px;

  button {
    text-transform: capitalize;
  }
`

export const ButtonWithIcon = styled(Button)`
  padding: 3px;
  color: ${colors.sonicSilver};
  min-width: auto;
  border-radius: 100%;
  &:hover {
    color: ${colors.blue.hover};
  }
`

export const menu = css`
  a {
    text-decoration: none;
    color: inherit;
  }
`

export const button = css`
  padding: 3px 10px;
  font-size: 12px;
  text-transform: capitalize;
  color: ${colors.sonicSilver};
`

export const hoverable = css`
  cursor: pointer;

  :hover {
    cursor: pointer;
  }
`

export const menuItem = css`
  min-height: auto;
`

export const typography = css`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0.15px;
  color: rgba(0, 0, 0, 0.87);
`

export const marginRight = css`
  margin-right: 25px;
`

export const FlexBreak = styled.div`
  flex-basis: 100%;
  height: 0;
`
